// Copyright (c) 2016 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import SearchFilters from '../../../shared/state/search-filters';
import TranslatedInput from '../../../shared/components/translated-input';
import TranslatedOption from '../../../shared/components/translated-option';

const sortMap = {
    ASC: 'ascending',
    DESC: 'descending'
};

const handleSortDirectionChange = props => () => {

    const direction = props.searchFilters.sortDirection === 'ASC' ?
        'DESC' :
        'ASC';

    props.onSortDirectionChange(direction, props.type);

};

const handleFilterByChange = props => event => {

    props.onFilterByChange(event.target.value, props.type);

};

const handleSortByChange = props => event => {

    const option = event.target.value.split(',');

    props.onSortByChange(option, props.type);

};

const RefinableListWidget = props => {

    const sortClassName = sortMap[props.searchFilters.sortDirection];

    return (
        <div className='refinable-list'>
            <div className='rounded-bar-filter'>
                <span className='icon-search'/>
                <TranslatedInput
                    onChange={handleFilterByChange(props)}
                    placeholder='FILTER_PLACEHOLDER'
                    type='text'
                    value={props.searchFilters.filterBy}
                />
            </div>
            <div className='rounded-bar-sort'>
                <div className='sort-by-group'>
                    <label>
                        <FormattedMessage id='SORT_BY'/>
                    </label>
                    <select
                        onChange={handleSortByChange(props)}
                        value={props.searchFilters.sortBy.toString()}
                    >
                        {props.sortOptions.map(option =>
                            <TranslatedOption
                                key={option.displayName}
                                text={option.displayName}
                                value={String(option.path)}
                            />
                        )}
                    </select>
                    <button
                        className='button-text'
                        onClick={handleSortDirectionChange(props)}
                        type='button'
                    >
                        <span className={`sort-control ${sortClassName}`}/>
                    </button>
                </div>
            </div>
        </div>
    );

};

RefinableListWidget.displayName = 'RefinableListWidget';
RefinableListWidget.propTypes = {
    onFilterByChange: PropTypes.func.isRequired,
    onSortByChange: PropTypes.func.isRequired,
    onSortDirectionChange: PropTypes.func.isRequired,
    searchFilters: PropTypes.instanceOf(SearchFilters).isRequired,
    sortOptions: PropTypes.array.isRequired,
    type: PropTypes.func
};

export default RefinableListWidget;



// WEBPACK FOOTER //
// ./src/shared/components/refinable-list-widget/index.js